export const tradeStats = [
  { label: 'Total Trade Volume', value: '$4.2B', change: '+18.3%', up: true },
  { label: 'Active Companies', value: '1,240+', change: '+12.1%', up: true },
  { label: 'Shipments Processed', value: '38,500', change: '+22.7%', up: true },
  { label: 'Partner Nations', value: '24', change: '+4', up: true },
];

export const monthlyTradeVolume = [
  { month: 'Jan', korea: 280, vietnam: 240 },
  { month: 'Feb', korea: 310, vietnam: 260 },
  { month: 'Mar', korea: 340, vietnam: 290 },
  { month: 'Apr', korea: 300, vietnam: 310 },
  { month: 'May', korea: 390, vietnam: 340 },
  { month: 'Jun', korea: 420, vietnam: 370 },
  { month: 'Jul', korea: 450, vietnam: 400 },
  { month: 'Aug', korea: 470, vietnam: 420 },
  { month: 'Sep', korea: 510, vietnam: 460 },
  { month: 'Oct', korea: 490, vietnam: 480 },
  { month: 'Nov', korea: 530, vietnam: 510 },
  { month: 'Dec', korea: 580, vietnam: 540 },
];

export const tradeCategories = [
  { category: 'Electronics', korea: 42, vietnam: 35 },
  { category: 'Textiles', korea: 18, vietnam: 28 },
  { category: 'Machinery', korea: 24, vietnam: 16 },
  { category: 'Agriculture', korea: 8, vietnam: 18 },
  { category: 'Chemicals', korea: 12, vietnam: 10 },
  { category: 'Others', korea: 16, vietnam: 13 },
];

export const tradeDistribution = [
  { name: 'Electronics & Tech', value: 38, color: '#0A1628' },
  { name: 'Textiles & Apparel', value: 23, color: '#C0C5CE' },
  { name: 'Industrial Machinery', value: 20, color: '#1A2B4A' },
  { name: 'Agricultural Products', value: 13, color: '#9BA3AF' },
  { name: 'Others', value: 6, color: '#E8EAED' },
];

export const keyMetrics = [
  { label: 'Export Value Korea→Vietnam', value: '$2.1B', trend: '+21%' },
  { label: 'Export Value Vietnam→Korea', value: '$2.1B', trend: '+16%' },
  { label: 'YoY Trade Growth', value: '18.3%', trend: '+3.2pp' },
  { label: 'Active Trade Agreements', value: '7', trend: '+1' },
];
